import React, { useEffect, useState } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import getUserInfo from '../../services/getUserInfo';
import Pagination from '../../components/Pagination';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

import { Link } from 'react-router-dom';
import moment from "moment";
import 'moment/locale/pt-br';
import '../../../node_modules/react-vis/dist/style.css';

import Header from '../../components/Header';
import ModalRegion from '../../components/modals/ModalRegion';
import InputDate from '../../components/inputs/InputDate';
import ModalShift from '../../components/modals/ModalShift';
import ItensPage from '../../components/ItensPage';

import trophy2 from '../../assets/images/trophy2.svg';
import search from '../../assets/images/search.svg';
import br from '../../assets/images/brazil.svg';
import sp from '../../assets/images/sp.svg';
import rj from '../../assets/images/rj.svg';
import tooltip from '../../assets/images/tooltip-orange.svg';
import tooltip2 from '../../assets/images/tooltip-grey.svg';
import polygonUp from '../../assets/images/polygonUp.svg';
import polygonDown from '../../assets/images/polygonDown.svg';
import pin2 from '../../assets/images/pin2.svg';

import api from '../../services/api';
import axios from 'axios';
import { Loading } from '../../components/ResponsiveLoading';
import { createUrlParamsFromObject, getRegionFromUrl, getUrlParam } from '../../services/helpers';


export const SalesDetails = () => {
  const origin = localStorage.getItem('origin');

  const [showRegions, setShowRegions] = useState(false);
  const [showShiftsProduct, setShowShiftsProduct] = useState(false);
  const [loadingShifts, setLoadingShifts] = useState(false);
  const [loadingProdutosPlantoes, setLoadingProdutosPlantoes] = useState(false);
  const [shiftsProduct, setShiftsProduct] = useState([]);
  const [totalShiftsProduct, setTotalShiftsProduct] = useState(0);
  const [allShifts, setAllShifts] = useState([]);
  const [filter, setFilter] = useState({});
  const [region, setRegion] = useState({});
  const [updateFilter, setUpdateFilter] = useState([]);
  const [startDate, setStartDate] = useState('');
  const [finalDate, setFinalDate] = useState('');
  const [sales, setSales] = useState([]);
  const [searchInput, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [loading, setLoading] = useState(true);
  const [perPage, setPerPage] = useState(10);

  const [sortBy, setSortBy] = useState(getUrlParam('sort_by') ?? 'data');
  const [sortDir, setSortDir] = useState(getUrlParam('sort_dir') ?? 'desc');

  const [totalSales, setTotalSales] = useState(0);

  const [userInfo, setUserInfo] = useState({});

  const [icon] = useState({
    'br': br,
    'sp': sp,
    'rj': rj
  });

  const selectOptions = {
    salesforce_pv: 'Código PV',
    search_responsavel: 'Responsável',
    search_unidade_torre: 'Unidade'
  };

  useEffect(() => {
    getUserInfo().then(user => {
      setUserInfo(user);
    });

    window.handleRegion = (id, nome, slug) => {
      let region = { id, nome, slug };
      handleRegion(region);
    };

    let urlStartDate = getUrlParam('start_date');
    let urlFinalDate = getUrlParam('final_date');

    let toStartDate = urlStartDate ? new Date(urlStartDate+'T00:00:00') : new Date();
    let toFinalDate = urlFinalDate ? new Date(urlFinalDate+'T00:00:00') : new Date();

    let toRegion = getRegionFromUrl();
    let regionId = toRegion?.id ?? null;

    let plantoesIds = getUrlParam('plantoes_ids');
    let toShiftsProduct = [];
    if(plantoesIds && plantoesIds.length > 0){
      toShiftsProduct = plantoesIds.split(',');
    }
    
    setShiftsProduct(toShiftsProduct);
    setStartDate(toStartDate);
    setFinalDate(toFinalDate);
    setRegion(toRegion);


    let filters = {
      plantoes_ids: plantoesIds,
      date_start: moment(toStartDate).format('YYYY-MM-DD'),
      date_end: moment(toFinalDate).format('YYYY-MM-DD'),
      regional_id: regionId
    }

    setLoading(true);
    getSales(filters);
    setFilter(filters);
    getShifts(regionId);
  }, []);

  useEffect(() => {
    if(sales.length > 0){
      setLoading(true);
      getSales(filter);
    }
  }, [updateFilter, page, sortBy, sortDir, perPage]);

  useEffect(() => {
    updateUrlParams();
  }, [sortBy, sortDir, region, startDate, finalDate, shiftsProduct]);

  const updateUrlParams = () => {
    const params = {
      sort_by: sortBy,
      sort_dir: sortDir,
      start_date: moment(startDate).format('YYYY-MM-DD'),
      final_date: moment(finalDate).format('YYYY-MM-DD'),
      plantoes_ids: shiftsProduct.join(',')
    };

    if(Object.keys(region).length > 0){
      params.region_id = region.id;
      params.region_nome = region.nome;
      params.region_slug = region.slug;
    }

    const urlParams = createUrlParamsFromObject(params);
    
    window.history.replaceState(null, null, `${window.location.pathname}?${urlParams}`);
  }

  const getSales = async (filters = {}) => {
    if (typeof cancelToken != typeof undefined) {
      window.cancelToken.cancel()
    }

    window.cancelToken = axios.CancelToken.source();

    let params = { 
      ...filters, 
      page,
      per_page: perPage,
      sort_by: sortBy,
      sort_dir: sortDir
    };

    if(allShifts.length > 0 && allShifts.length === shiftsProduct.length && typeof params.plantoes_ids !== 'undefined'){
     delete params.plantoes_ids;
     console.log('del', filters);
    }

    const { data, status } = await api.get(`vendas`, {
      params,
      cancelToken: window.cancelToken.token
    });

    if (status === 200) {
      setPageCount(data._pagination.last_page);
      setTotalSales(data._pagination.total);
      setSales(data.vendas);
    }
    setLoading(false);
  }

  const handleRegion = (newRegion) => {
    let cFilter = filter;
    let regionId = newRegion.id;

    cFilter.regional_id = regionId;
    
    if(newRegion.id !== region.id){
      delete cFilter.plantoes_ids;
    }

    setRegion(newRegion);
    setShowRegions(false);
    
    setLoading(true);
    getShifts(regionId);
    getSales(cFilter); 
    setFilter(cFilter);
  }

  const getShifts = async (regionId = null) => {
    setLoadingShifts(true);

    const { data, status } = await api.get(`list-plantoes`, {
      params: {
        reginal_id: regionId
      }
    });

    let totalShifts = 0;
    let shifts = [];

    data.regionais.map(regional => {
      if(regionId !== null && regional.id !== regionId) return;

      totalShifts += regional.plantoes.length;
      regional.plantoes.map(plantao => {
        shifts.push(plantao.id);
      });
    });

    setShiftsProduct(shifts);
    setAllShifts(shifts);
    setLoadingShifts(false);
  }

  const handleDate = (start, final) => {
    setPage(1);
    let cFilter = filter;
    cFilter.date_start = moment(start).format('YYYY-MM-DD');
    cFilter.date_end = moment(final).format('YYYY-MM-DD');
    setFilter(cFilter);
    setStartDate(start);
    setFinalDate(final);

    setLoading(true);
    getSales(cFilter);    
  }

  const handleShiftProduct = (shifts) => {
    setShowShiftsProduct(false);
    console.log(shifts);
    let cFilter = filter;
    filter.plantoes_ids = shifts.join(',');
    setShiftsProduct(shifts);
    setFilter(cFilter);
    setUpdateFilter(!updateFilter);
  }

  const changeOrder = (e, by) => {
    e.preventDefault();
    
    if(sortBy === by){
      setSortDir(prev => prev === 'asc' ? 'desc' : 'asc');
    } else {
      setSortBy(by);
      setSortDir('desc');
    }
  }

  const ColumnTitle = ({name, value}) => {
    return (
      <a href="#" onClick={e => changeOrder(e, value)}>{name}
        {value &&
          <div className="orderBy">
            {((sortDir === 'asc' && sortBy === value) || sortBy !== value) &&
              <img src={polygonUp} />
            }
            {((sortDir === 'desc' && sortBy === value) || sortBy !== value) &&
              <img src={polygonDown} />
            }
          </div>
        }
      </a>
    );
  }

  const [selectedOption, setSelectedOption] = useState('salesforce_pv');
  const [term, setTerm] = useState('');

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const gerarUrlPorTipo = (tipo, id) => {
    const urns = {
      corretor: 'brokers',
      gerente: 'managers',
      superintendente: 'super',
      diretor: 'directors'
    }

    let urn = urns[tipo];

    if(typeof urn !== 'undefined'){
      return `/${urns[tipo]}/${id}`;
    }

    return null;
  }

  const TdResponsavel = ({sale}) => {

    let url = gerarUrlPorTipo(sale.tipo, sale.responsavel.id);

    return (
      <td>
        <div className={`tag ${sale.tipo}`}>{sale.tipo}</div>
        {url &&
          <a href={url}>
            {sale.responsavel.nome}
          </a>
        }
        {!url && sale.responsavel.nome}
      </td>
    );
  }

  const handleChangeTerm = event => {
    let value = event.target.value;
    console.log('v1', value); 
    if(selectedOption === 'salesforce_pv'){
      value = value.replace(/\D/g, '');
    }
    console.log('v', value);
    setTerm(value);
  }

  const handleSearch = event => {
    event.preventDefault();
    setPage(1);
    let cFilter = filter;
    if(term.length > 0){
      cFilter.search_by = selectedOption;
      cFilter.search_for = term;
    } else {
      delete cFilter.search_by;
      delete cFilter.search_for;
    }

    setFilter(cFilter);
    setLoading(true);
    getSales(cFilter);
  }

  return (
    <>
      {showRegions &&
        <ModalRegion handleClose={() => setShowRegions(false)} handleRegion={handleRegion} handleShift={handleShiftProduct} />
      }
      {showShiftsProduct &&
        <ModalShift 
          region={region} 
          handleClose={() => setShowShiftsProduct(false)} 
          handleShift={handleShiftProduct} 
          shifts={shiftsProduct} 
        />
      }
      <section id="content">
        <Header icon={<img src={trophy2} />} title="Vendas" showBeta={false} />
        <div className="pd-37">
          <div className="box-header box-header-wrap">
            
            <div className="box-tools">
              {userInfo?.isMaster && origin !== 'app' &&
                <button className="btn-filter btn-box-shadow" style={{ minWidth: 180 }} onClick={() => setShowRegions(true)}>
                  {loading &&
                    <Loading cWidth={120} cHeight={40} />
                  }
                  {!loading &&
                    <>
                      <img src={icon[region.slug] ?? br} />
                      <span>{region.nome ?? 'Brasil'}</span>
                    </>
                  }
                </button>
              }
              <button className="btn-filter btn-box-shadow" style={{ minWidth: 250 }} onClick={() => setShowShiftsProduct(true)}>
                {(loadingProdutosPlantoes || loadingShifts) &&
                  <Loading cWidth={220} cHeight={40} />
                }
                {!loadingProdutosPlantoes && !loadingShifts &&
                  <>
                    <img src={pin2} />
                    {(allShifts.length === 0 || shiftsProduct.length === 0) &&
                      <span>Produto</span>
                    }
                    {allShifts.length > 0 && shiftsProduct.length > 0 &&
                      <span>{shiftsProduct.length === allShifts.length ? `Todos os produtos` : `${shiftsProduct.length} Produto${shiftsProduct.length !== 1 ? 's' : ''}`}</span>
                    }
                  </>
                }
              </button>
              <InputDate className="btn-box-shadow" cStartDate={startDate} cFinalDate={finalDate} handleDate={handleDate} />            
            </div>
            <div className="box-tools">
            <Form className="form-search" onSubmit={handleSearch}>
                <div className="select-sales">
                  <div style={{display: "flex"}}>
                    <div>
                      <img src={search} />
                      <select className="btn-filter btn-box-shadow select-sales-options" value={selectedOption} onChange={handleSelectChange}>
                        {Object.keys(selectOptions).map((option, index) => (
                          <option key={index} value={option}>{selectOptions[option]}</option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <Form.Control 
                        name="term"
                        className="btn-filter btn-box-shadow input-sales-options" 
                        id="btn-search" 
                        type="text" 
                        value={term}
                        onChange={handleChangeTerm}
                        placeholder={`${selectOptions[selectedOption]}`} 
                      />
                    </div>
                  </div>
                  <div>
                    <button className="btn-update btn-search-sales" type="submit">Buscar</button>
                  </div>
                </div>
            </Form>
            </div>
          </div>
          <div className="box-body">
            <div className="result-filter-sales">
              <p className="total-message">Resultado: <b>{totalSales.toLocaleString('pt-BR')} {totalSales === 1 ? 'venda' : 'vendas'}</b></p>
            </div>
            <Row>
              <Col sm={12}>
                <div className="box-card h-full">
                  <div className="box-card-noPadding">
                    <table className="table-dash table-border table-flex table-color">
                      <thead>
                        <tr className="light-blue">
                          <th>
                            <ColumnTitle value="salesforce_pv" name="Código PV" />
                          </th>
                          <th className="w-95 px-5">
                            <ColumnTitle value="data" name="Data de assinatura" />
                          </th>
                          {/* <th className="w-95 px-5">
                            <ColumnTitle name="Data de exclusão" />
                          </th> */}
                          <th>
                            <ColumnTitle value="search_produto" name="Produto" />
                          </th>
                          <th>
                            <ColumnTitle value="search_unidade_torre" name="Unidade" />
                          </th>
                          <th>
                            <ColumnTitle value="search_responsavel" name="Responsável" />
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {!loading && sales.map((sale, index) => (
                          <tr key={index}>
                            <td><a href={sale.salesforce.link} target="_blanl">{sale.salesforce.pv}</a>
                            </td>
                            <td>{moment(sale.data).format('DD/MM/YYYY')}</td>
                            {/* <td>
                              -
                            </td> */}
                            <td>{sale?.plantao?.nome ?? ''}</td>
                            <td>{sale?.unidade ?? ''}</td>
                            <TdResponsavel sale={sale} />
                          </tr>
                        ))}
                        {loading &&
                          <tr>
                            <td colSpan={6}>Carregando...</td>
                          </tr>
                        }
                        {!loading && sales.length === 0 &&
                          <tr>
                            <td colSpan={5}>Nenhum resultado encontrado</td>
                          </tr>
                        }

                      </tbody>
                    </table>
                  </div>
                </div>
              </Col>
            </Row>
            <ItensPage perPage={perPage} setPerPage={setPerPage} />
            <Pagination
              page={page}
              setPage={setPage}
              pageCount={pageCount}
            />
          </div>
        </div>
      </section>
    </>
  );

}

export default SalesDetails;